module.exports = __webpack_public_path__ + "img/thumbnail_Markhor_j_normal.a4f06e98.png";